import { fillVariants } from "../../../../styles/utils/fill"
import { classNames } from "../../../../utils"
import type { IconProps } from "../../../types"

export const Star = ({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="Star"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m354-247 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-80l65-281L80-550l288-25 112-265 112 265 288 25-218 189 65 281-247-149L233-80Zm247-350Z" />
    </svg>
  )
}
